import styled from 'styled-components';
import ds from 'designsystem';

const BurgerWrapper = styled.div`
  position: fixed;
  top: calc(${ds.get('metrics.s')} + 2px);
  right: ${ds.get('metrics.s')};
  z-index: 1000;
  cursor: pointer;
`;

export default BurgerWrapper;



// WEBPACK FOOTER //
// ./src/blocks/Navigation/MobileNavigation/BurgerWrapper.jsx